<template>
  <div class="search">
    <div class="banxin">
      <div class="head" style="height: 10px">
        <!-- <div class='all'>全部结果</div>
        <div class='arrow'></div>
        <div class='keyword'>“{{keyword}}”</div>
        <div class='arrow'></div> -->
      </div>
      <div class="result">
        <!-- <div class="sort">
          <div>排序：</div>
          <div
            class="default"
            :class="index == '1' ? 'active' : ''"
            @click="defaultSort()"
          >
            默认
          </div>
          <div
            class="sales"
            :class="index == '3' ? 'active' : ''"
            @click="salesSort()"
          >
            销量
            <img
              v-show="index !== '3'"
              src="../../../static/image/reduce@2x.png"
              alt=""
            />
            <img
              v-show="index == '3' && volume == 1"
              src="../../../static/image/reduce2@2x.png"
              alt=""
            />
            <img
              v-show="index == '3' && volume == 2"
              src="../../../static/image/reduce1@2x.png"
              alt=""
            />
          </div>
          <div
            class="price"
            :class="index == '2' ? 'active' : ''"
            @click="priceSort()"
          >
            价格
            <div class="arr">
              <div class="up" :class="type == 1 ? 'low' : ''"></div>
              <div class="down" :class="type == 2 ? 'high' : ''"></div>
            </div>
          </div>
          <div class="priceBox" v-if="searchVal == '商品'">
            <div class="min">¥<input type="number" v-model="minMoney" /></div>
            <div style="margin: 0 8px">-</div>
            <div class="max">¥<input type="number" v-model="maxMoney" /></div>
            <div class="btn" @click="priceSearch">确定</div>
            <div class="clear" @click="clearMoney">清空</div>
          </div>
        </div> -->
        <div
          class="pro"
          v-if="searchVal == '商品' && noProduct == false"
          v-loading="loading"
        >
          <ProductList :productList="productList"></ProductList>
        </div>
        <div class="empty" v-if="searchVal == '商品' && noProduct == true">
          <!--  && network == false -->
          <img src="../../../static/image/nosearch@2x.png" alt="" />
          <p class="fs20 font-color-999">
            搜索不到您要找的商品呢换个词试试吧～
          </p>
        </div>
        <div></div>
        <div
          class="empty"
          v-if="searchVal == '店铺' && noShop == true && network == false"
        >
          <img src="../../../static/image/nosearch@2x.png" alt="" />
          <p class="fs20 font-color-999">
            搜索不到您要找的店铺呢换个词试试吧～
          </p>
        </div>
        <!-- <div class="network" v-if="searchVal=='商品' && noProduct==true && network==true"> -->
        <div class="network" v-if="network">
          <img src="../../../static/image/poornetwork@2x.png" alt="" />
          <p class="fs20 font-color-999">哎呀，网络开小差了～</p>
        </div>

        <div
          class="store"
          v-if="searchVal == '店铺' && noShop == false"
          v-loading="loading1"
        >
          <div
            class="storeBox"
            style="
              width: 48%;

              margin: 10px 10px;
              padding: 10px;
              background-color: #ffffff;
            "
            v-for="(item, index) in storeList"
            :key="index"
          >
            <div class="top">
              <img
                class="storeImg"
                v-if="item.shopLogo"
                :src="item.shopLogo"
                alt=""
              />
              <img
                class="storeImg"
                v-else
                src="../../assets/images/logo.png"
                alt=""
              />
              <div class="storeDesc">
                <p class="storeName">{{ item.shopName }}</p>
                <img
                  style="width: 80px; height: 27px"
                  src="../../assets/images/renzheng.png"
                  alt=""
                />
                <img
                  src="../../assets/images/qiye.png"
                  style="width: 19px; height: 24px; margin-left: 20px"
                  alt=""
                />
                <span style="margin-left: 5px">一年</span>
                <i class="icon-positioning" style="margin-left: 20px"></i>
                <span class="storeSite">所在地：{{ item.shopAdress }}</span>
                <span style="margin-left: 10px"> 主营产品：食品百货</span>
              </div>
              <div class="enter" @click="toStore(item.shopId)">
                <div class="jindian">进店></div>
              </div>
            </div>
            <div
              class="content"
              style="background: none !important"
              v-if="item.skus.length"
            >
              <div
                class="productBox"
                v-for="(items, indexs) in item.skus"
                v-if="indexs < 4"
                :key="indexs"
                @click="toProductDetail(item.shopId, items)"
              >
                <img :src="items.image" alt="" />
                <!-- <p class="productName">{{ items.productName }}</p> -->
                <!-- <p class="price">¥{{ items.price }}</p> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="">
      <el-pagination
        v-if="productList.length > 0 || storeList.length > 0"
        :current-page="page"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import api from "../../api";
import { listSearchMixin } from "../../config/mixin";
import ProductList from "../../components/base/productList";
import { mapGetters, mapState } from "vuex";
export default {
  mixins: [listSearchMixin],
  components: {
    ProductList,
  },
  data() {
    return {
      flag: true,
      page: sessionStorage.getItem("curentPage") || 1,
      keyword: "",
      searchVal: "",
      index: "1",
      maxMoney: "",
      minMoney: "",
      type: "",
      volume: "",
      productList: [],
      total: 0,
      pageSize: 20,
      network: false,
      noProduct: false,
      noShop: false,
      storeList: [],
      loading: false,
      loading1: false,
    };
  },
  mounted() {
    if (this.$route.query.search) {
      this.searchInfoShop();
      
    } else {
      this.searchInfo();
    }
    console.log(this.searchObj);
  },
  computed: {
    ...mapGetters(["searchObj"]),
  },
  methods: {
    searchInfo() {
      if (this.searchObj.keyword !== undefined) {
        this.keyword = this.searchObj.keyword;
        this.searchVal = this.searchObj.searchVal;
        this.maxMoney = "";
        this.minMoney = "";
        if (this.searchVal === "商品") {
          this.getSearchProducts();
        } else {
          this.getShops();
        }
      }
    },
    searchInfoShop() {
      this.keyword = this.$route.query.search;
      this.searchVal = "商品";
      this.getSearchProducts();
    },
    // 跳转商品详情
    toProductDetail(id, item) {
      let data = {
        shopId: id,
        productId: item.productId,
        skuId: item.skuId,
      };
      this.$router.push({
        path: "/productDetail",
        query: {
          proData: JSON.stringify(data),
        },
      });
    },
    // 获取搜索商品数据
    getSearchProducts() {
      let self = this;
      self.loading = true;
      self.pageSize = 20;
      sessionStorage.setItem("curentPage", self.page);
      if (sessionStorage.getItem("curentPage")) {
        self.page = sessionStorage.getItem("curentPage");
      }
      let params = {
        url:
          api.getSearchProducts +
          `?search=${self.keyword}&type=${self.type}&maxMoney=${self.maxMoney}&minMoney=${self.minMoney}&volume=${self.volume}&page=${self.page}&pageSize=${self.pageSize}`,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.productList = res.data.list;
          self.total = res.data.total;
          self.loading = false;
          self.network = false;
          if (res.data.list.length < 1) {
            self.noProduct = true;
          } else {
            self.noProduct = false;
          }
          
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
          self.network = true;
        }
      });
    },
    // 获取搜索店铺数据
    getShops() {
      let self = this;
      self.loading1 = true;
      self.pageSize = 10;
      let params = {
        url:
          api.getShops +
          `?search=${self.keyword}&type=${self.type}&volume=${self.volume}&page=${self.page}&pageSize=${self.pageSize}`,
        method: "GET",
        data: {},
      };
      self.sendReq(params, (res) => {
        if (res.code === "200") {
          self.storeList = res.data.list;
          self.total = res.data.total;
          self.loading1 = false;
          self.network = false;
          if (res.data.list.length === 0) {
            self.noShop = true;
          } else {
            self.noShop = false;
          }
        } else {
          self.$message({
            message: res.message,
            type: "warning",
          });
          self.network = true;
        }
      });
    },
    // 跳转到店铺
    toStore(id) {
      this.$router.push({
        path: "/store",
        query: { shopId: id },
      });
    },
    // 价格搜索
    priceSearch() {
      this.page = 1;
      this.getSearchProducts();
    },
    handleCurrentChange(val) {
      this.page = val;
      if (this.searchVal === "商品") {
        this.getSearchProducts();
      } else {
        this.getShops();
      }
    },
    // 清空价格搜索
    clearMoney() {
      this.minMoney = "";
      this.maxMoney = "";
    },
    // 默认排序
    defaultSort() {
      this.type = "";
      this.volume = "";
      this.index = "1";
      this.page = 1;
      this.maxMoney = "";
      this.minMoney = "";
      if (this.searchVal === "商品") {
        this.getSearchProducts();
      } else {
        this.getShops();
      }
    },
    // 价格排序
    priceSort() {
      if (this.type !== 1) {
        this.type = 1;
      } else {
        this.type = 2;
      }
      this.page = 1;
      this.index = "2";
      this.volume = "";
      this.maxMoney = "";
      this.minMoney = "";
      if (this.searchVal === "商品") {
        this.getSearchProducts();
      } else {
        this.getShops();
      }
    },
    // 销量排序
    salesSort() {
      if (this.volume !== 1) {
        this.volume = 1;
      } else {
        this.volume = 2;
      }
      this.page = 1;
      this.index = "3";
      this.type = "";
      this.maxMoney = "";
      this.minMoney = "";
      if (this.searchVal === "商品") {
        this.getSearchProducts();
      } else {
        this.getShops();
      }
    },
  },
  watch: {
    searchObj: {
      handler(newVal, oldVal) {
        this.page = 1;
        this.searchInfo();
      },
      deep: true,
    },
  },
};
</script>
<style lang = 'scss' scoped>
>>> .product {
  width: 100% !important;
}
.search {
  width: 100%;
  height: 100%;
  background-color: #f0f0f0;
  padding-bottom: 143px;
  text-align: center;
  .banxin {
    width: 1612px;
    height: 100%;
    margin: 0 auto;
    .head {
      width: 100%;
      height: 64px;
      line-height: 64px;
      font-size: 16px;
      display: flex;
      align-items: center;
      .all {
        margin-right: 20px;
      }
      .keyword {
        margin: 0 20px;
        color: #ff7800;
      }
      .arrow {
        background-image: url("../../../static/image/xiangyou@2x.png");
        width: 5px;
        height: 10px;
      }
    }
    .result {
      width: 100%;
      /* background-color: #ffffff; */
      box-sizing: border-box;
      margin-bottom: 30px;
      /* padding: 0 20px 30px; */
      .sort {
        width: 100%;
        height: 63px;
        line-height: 27px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #f1f1f1;
        color: #666666;
        margin-bottom: 28px;
        .default {
          margin-left: 20px;
          cursor: pointer;
        }
        .sales {
          margin-left: 20px;
          cursor: pointer;
          img {
            width: 9px;
            height: 16px;
            vertical-align: middle;
          }
        }
        .price {
          display: flex;
          margin: 0 20px;
          cursor: pointer;
          .arr {
            vertical-align: middle;
            width: 12px;
            margin-left: 3px;
            .up {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-bottom-color: #999999;
            }
            .down {
              width: 0;
              height: 0;
              border: 6px solid transparent;
              border-top-color: #999999;
              margin-top: 3px;
            }
          }
        }
        .active {
          color: #ff7800;
          .arr {
            .high {
              border-top-color: #ff7800;
            }
            .low {
              border-bottom-color: #ff7800;
            }
          }
        }
        .priceBox {
          display: flex;
          .min,
          .max {
            display: flex;
            width: 100px;
            height: 28px;
            padding: 0 5px;
            border: 1px solid #ccc;
            box-sizing: border-box;
            input {
              width: 70px;
              flex: 1;
              outline: none;
              border: none;
            }
          }
          .btn {
            width: 50px;
            height: 28px;
            border: 1px solid #ccc;
            box-sizing: border-box;
            cursor: pointer;
            margin: 0 20px;
          }
          .clear {
            cursor: pointer;
            color: #999999;
          }
        }
      }
      .empty,
      .network {
        width: 100%;
        text-align: center;
        padding: 100px 0;
      }
      .store {
        /* flex: 2; */

        width: 100%;
        box-sizing: border-box;
        min-height: 400px;
        .storeBox {
          display: inline-block;
          width: 100%;
          margin-bottom: 50px;
          .top {
            margin-top: 10px;
            display: flex;
            .storeImg {
              width: 40px;
              height: 40px;
              margin-right: 10px;
            }
            .storeDesc {
              height: 80px;
              flex: 1;
              text-align: left;
              .storeName {
                font-size: 20px;
                margin-bottom: 10px;
                margin-top: 7px;
              }
              .storeSite {
                font-size: 14px;
              }
            }
            .enter {
              /* color: #ff7800; */
              width: 66px;
              height: 34px;
              border-radius: 4px;
              border: 1px solid #f77b0b;
              font-size: 14px;
              text-align: center;

              color: #f77b0b;
              line-height: 28px;
              .jindian {
                margin-top: 4px;
                cursor: pointer;
              }
            }
          }
          .content {
            display: flex;
            width: 100%;
            margin-left: 45px;
            overflow: hidden;
            padding: 20px 10px;
            box-sizing: border-box;
            background: none !important;
            /* border: 1px solid #e5e5e5; */
            .productBox {
              cursor: pointer;

              width: 20%;
              padding: 10px 15px;
              margin-right: 20px;
              box-sizing: border-box;
              background-color: #ffffff !important;
              img {
                width: 100%;
                border-radius: 8px;
                height: 113px;
              }
              .productName {
                font-size: 12px;
                font-weight: bold;
                margin: 13px 0;
              }
              .price {
                font-size: 16px;
                color: #ff7800;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
    .guessYouLike {
      width: 100%;
      padding: 30px 45px;
      background-color: #ffffff;
      box-sizing: border-box;
      .title {
        text-align: left;
        font-size: 26px;
        margin-bottom: 22px;
      }
    }
  }
}
>>> .el-pagination {
  text-align: right;
  .el-pager {
    li:not(.disabled):hover {
      color: #ff7800;
    }
    li:not(.disabled).active {
      background-color: #ff7800;
    }
    li:not(.disabled).active:hover {
      color: #f4f4f5;
    }
  }
}
.recommendPage {
  padding: 0 56px;
  box-sizing: border-box;
  position: relative;
  .swiper-container {
    position: static;
    width: 100%;
    .swiper-slide {
      width: 100%;
      text-align: center;
      img {
        width: 100%;
        height: 229px;
        margin-bottom: 20px;
      }
      .name {
        font-size: 13px;
        font-weight: bold;
      }
      .price {
        margin: 12px 0;
        .presentPrice {
          font-size: 15px;
          color: #ff7800;
          font-weight: bold;
        }
        .originalPrice {
          font-size: 13px;
          color: #666666;
          text-decoration: line-through;
        }
      }
      .line {
        width: 130px;
        height: 2px;
        background-color: #f0f0f0;
        margin: 0 auto;
        margin-bottom: 10px;
      }
      .desc {
        font-size: 13px;
        color: #999999;
      }
    }
  }
}
.mySwiperLbtn {
  width: 32px;
  height: 32px;
  background-image: url("../../../static/image/zuoa@2x.png");
  background-size: cover;
  left: 0;
}
.mySwiperRbtn {
  width: 32px;
  height: 32px;
  background-image: url("../../../static/image/youa@2x.png");
  background-size: cover;
  right: 0;
}
.pro {
  min-height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/search/index.vue